<template>
  <div class="chart-container w-100">
    <apexchart type="bar" :height="chartHeight" width="100%" :options="chartOptions" :series="series"/>
  </div>
</template>

<script>
export default {
  name: 'HeadcountWorkLocationChart',
  props: {
    chartSeries: {
      type: Array,
      required: true
    },
    chartHeight: {
      type: [Number, String],
      default: 400
    },
    companyPrimaryColor: {
      type: String,
      default: '#006859'
    }
  },
  computed: {
    sortedData() {
      const known = this.chartSeries.filter(item => item.location !== 'Unknown')
      const unknown = this.chartSeries.filter(item => item.location === 'Unknown')
      return [...known.sort((a, b) => b.headcount - a.headcount), ...unknown]
    },
    series() {
      return [{
        name: 'Headcount',
        data: this.sortedData.map(item => item.headcount)
      }]
    },
    chartOptions() {
      return {
        chart: {
          type: 'bar',
          toolbar: { show: false },
          fontFamily: 'Manrope, Arial, sans-serif'
        },     
        plotOptions: {
          bar: {
            horizontal: true
          }
        },
        xaxis: {
          categories: this.sortedData.map(item => item.location)
        },
        colors: [this.companyPrimaryColor],
        dataLabels: {
          enabled: true,
          formatter: function(val) {
            return val || ''
          },
          style: {
            fontFamily: 'Manrope',
            colors: ['#fff']
          }
        },
        tooltip: {
          y: { formatter: val => `${val} employees` }
        },
        legend: { show: false }
      }
    }
  }
}
</script>